export default "__VITE_ASSET__Baopkv3q__"